<template>
	<div class="text-center">
		<v-dialog
			v-model="show"
			width="600"
			@input="(v) => v || closeModal()"
			content-class="create-thread-modal overflow-x-hidden"
			@click:outside="closeModal"
		>
			<v-card class="create-thread-modal__card">
				<v-icon
					class="justify-end"
					style="width: 100%; cursor: pointer;"
					@click="closeModal"
				>
					mdi-close
				</v-icon>

				<div class="d-flex justify-space-between align-center flex-wrap">
					<div class="create-thread-modal__title">
						{{ edit ? 'Edit' : 'Create' }} Post
					</div>
				</div>

				<v-tabs v-model="tab" class="create-thread-modal__tabs-wrapper" >
					<v-tab class="create-threadmodal__tabs-wrapper_v-tabs">Text</v-tab>
					<v-tab class="create-threadmodal__tabs-wrapper_v-tabs" style="margin-left: -22px">Video</v-tab>
				</v-tabs>

				<v-tabs-items v-model="tab">
					<v-tab-item>
						<PostTextForm 
							v-on:closeModal="closeModal" 
							:activeTab="tab" 
							:edit="edit"
							:post="post"
						/>
					</v-tab-item>

					<v-tab-item>
						<PostTextForm
							v-on:closeModal="closeModal"
							:activeTab="tab"
							:edit="edit"
							:post="post"
						/>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PostTextForm from '@/components/Forms/PostTextForm'
export default {
	components: { PostTextForm },

	props: {
		show: {
			type: Boolean,
			default: false
		},
		edit: {
			type: Boolean,
			default: false
		},
		post: {
			type: Object,
			default: () => {}
		}
	},

	data: () => ({
		tab: null,
	}),

	methods: {
		...mapActions('chats', ['deleteMessage']),
		...mapActions('settings', ['fetchChapters', 'getAppCoreSettings']),

		closeModal() {
			this.$emit('closeModal')
		},

		getCurrentDate() {
			const date = new Date()
			const formattedDate = `${
				date.getMonth() + 1
			}/${date.getDate()}/${date.getFullYear()}, ${this.formatTime(date)}`
			return formattedDate
		},

		// Function to format the time in 12-hour format with AM/PM
		formatTime(date) {
			let hours = date.getHours()
			let minutes = date.getMinutes()
			const ampm = hours >= 12 ? 'pm' : 'am'
			hours %= 12
			hours = hours || 12 // Handle midnight (0 hours)
			minutes = minutes < 10 ? `0${minutes}` : minutes
			return `${hours}:${minutes} ${ampm}`
		},
	},

	computed: {
		...mapGetters('settings', ['chaptersList']),
		...mapGetters('post', ['isFileLoading', 'postFile']),
		...mapGetters('tag', ['tags']),
	},

	created() {
		if (!this.chaptersList) {
			this.fetchChapters()
		}
		if (this.edit && this.post) {
			this.tab = this.post.thread_type === 3 ? 1 : 0
		}
	},
}
</script>

<style lang="scss">
.create-threadmodal__tabs-wrapper_v-tabs{
	margin-left: -15px;
	margin-top: 20px;
	color: #9B9B9B;
	font-weight: 700;
	width: 30px;
	height: 17px;
}
.create-thread-modal {
	border-radius: 13px;

	&__card {
		padding: 35px;
	}
	&__title {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}
	&__time {
		color: rgb(74, 74, 74);
		font-size: 12px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
		letter-spacing: -0.29px;
		padding: 10px 0;
	}
	&__tabs-wrapper {
		padding-bottom: 10px;

		.v-slide-group__wrapper {
			border-bottom: 1px solid rgb(219, 219, 219);
		}
		.v-tabs-slider{
			width: 60px;
		}
	}
}
</style>
